import { Icon } from '@carrent/ui'
import { useAuthStore, useTheme } from '@carrent/core'
import { NotificationBell } from './NotificationBell'

export function TopBar({ onOpenSearch, onOpenNav }) {
  const { user } = useAuthStore()
  const { theme, toggle } = useTheme()

  const initials = (user?.full_name || '?')
    .split(' ')
    .slice(0, 2)
    .map((s) => s[0]?.toUpperCase() || '')
    .join('')

  const isMac = typeof navigator !== 'undefined' && /Mac/.test(navigator.userAgent)

  return (
    <header className="top-bar">
      <button type="button" className="top-bar__nav-toggle" onClick={onOpenNav} aria-label="Открыть меню">
        <Icon name="more" size={20} />
      </button>

      <button type="button" className="top-bar__search" onClick={onOpenSearch}>
        <Icon name="search" size={16} />
        <span className="top-bar__search-placeholder">Поиск…</span>
        <kbd className="top-bar__search-kbd">{isMac ? '⌘' : 'Ctrl'} K</kbd>
      </button>

      <div className="top-bar__right">
        <button
          type="button"
          className="btn btn--ghost btn--sm"
          onClick={toggle}
          aria-label={theme === 'light' ? 'Тёмная тема' : 'Светлая тема'}
        >
          <Icon name={theme === 'light' ? 'map' : 'home'} size={16} />
        </button>
        <NotificationBell />
        <div className="top-bar__avatar" aria-hidden="true">{initials}</div>
        <span className="top-bar__name">{user?.full_name || ''}</span>
      </div>
    </header>
  )
}
